// this exists only for readability.
// Seeing JSON.* in logic is clunky
export function cloneData<T = any>(obj: T): T {
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function stringifyEqual(a: any, b: any): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
